import { render } from "./shops_best.vue?vue&type=template&id=7d5614ae&scoped=true"
import script from "./shops_best.vue?vue&type=script&lang=js"
export * from "./shops_best.vue?vue&type=script&lang=js"

import "./shops_best.vue?vue&type=style&index=0&id=7d5614ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d5614ae"]])

export default __exports__